import React from 'react';

const ApartmentHouseForm = ({ formData, handleInputChange, errors }) => {
  return (
    <>
      {/* Common fields for apartment and house */}
      <div className="form-group">
        <label htmlFor="bedrooms">
          Bedrooms
        </label>
        <input
          type="number"
          id="bedrooms"
          name="bedrooms"
          value={formData.bedrooms}
          onChange={handleInputChange}
          required
          min="0"
          className="fancy-input"
          placeholder="Number of bedrooms"
        />
        {errors.bedrooms && <div className="error-text">{errors.bedrooms}</div>}
      </div>

      <div className="form-group">
        <label htmlFor="water_source">
          Water Source
        </label>
        <select
          id="water_source"
          name="water_source"
          value={formData.water_source}
          onChange={handleInputChange}
          required
          className="fancy-input"
        >
          <option value="">Select water source</option>
          <option value="no_water">No Water</option>
          <option value="council_water">Council Water</option>
          <option value="borehole">Borehole Water</option>
        </select>
        {errors.water_source && <div className="error-text">{errors.water_source}</div>}
      </div>

      <div className="checkboxes">
        <div className="form-group checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              name="has_parking_space"
              checked={formData.has_parking_space}
              onChange={handleInputChange}
            />
            Has Parking Space
          </label>
        </div>

        {formData.has_parking_space && (
          <div className="form-group">
            <label htmlFor="parking_slots">
              Number of Parking Slots
            </label>
            <input
              type="number"
              id="parking_slots"
              name="parking_slots"
              value={formData.parking_slots}
              onChange={handleInputChange}
              min="1"
              className="fancy-input"
              placeholder="Number of parking slots"
            />
            {errors.parking_slots && <div className="error-text">{errors.parking_slots}</div>}
          </div>
        )}

        <div className="form-group checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              name="has_power_backup"
              checked={formData.has_power_backup}
              onChange={handleInputChange}
            />
            Has Power Backup
          </label>
        </div>

        {formData.has_power_backup && (
          <div className="form-group">
            <label htmlFor="power_backup">
              Power Backup
            </label>
            <select
              id="power_backup"
              name="power_backup"
              value={formData.power_backup}
              onChange={handleInputChange}
              className="fancy-input"
            >
              <option value="">Backup options</option>
              <option value="solar_power">Solar Power</option>
              <option value="generator">Generator</option>
            </select>
            {errors.power_backup && <div className="error-text">{errors.power_backup}</div>}
          </div>
        )}

        <div className="form-group checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              name="is_deposit_required"
              checked={formData.is_deposit_required}
              onChange={handleInputChange}
            />
            Deposit Required
          </label>
        </div>

        {formData.is_deposit_required && (
          <div className="form-group">
            <label htmlFor="deposit_amount">
              Deposit Amount (USD)
            </label>
            <input
              type="number"
              id="deposit_amount"
              name="deposit_amount"
              value={formData.deposit_amount}
              onChange={handleInputChange}
              min="0"
              step="0.01"
              className="fancy-input"
              placeholder="Deposit amount"
            />
            {errors.deposit_amount && <div className="error-text">{errors.deposit_amount}</div>}
          </div>
        )}

        <div className="form-group checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              name="is_furnished"
              checked={formData.is_furnished}
              onChange={handleInputChange}
            />
            Furnished
          </label>
        </div>
      </div>

      <div className="checkboxes">


        <div className="form-group checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              name="is_gated"
              checked={formData.is_gated}
              onChange={handleInputChange}
            />
            Gated Community
          </label>
        </div>

      </div>

      <div className="checkboxes">
        {/* Apartment-specific fields */}
        {formData.property_type === 'apartment' && (
          <>
            <div className="form-group checkbox-group">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  name="has_gym"
                  checked={formData.has_gym}
                  onChange={handleInputChange}
                />
                Has Gym
              </label>
            </div>

            <div className="form-group checkbox-group">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  name="has_cctv"
                  checked={formData.has_cctv}
                  onChange={handleInputChange}
                />
                Has CCTV
              </label>
            </div>

            <div className="form-group checkbox-group">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  name="has_security"
                  checked={formData.has_security}
                  onChange={handleInputChange}
                />
                Has Security
              </label>
            </div>

            <div className="form-group checkbox-group">
              <label className="checkbox-label">
                <input
                  className="checkbox-input"
                  type="checkbox"
                  name="pets_allowed"
                  checked={formData.pets_allowed}
                  onChange={handleInputChange}
                />
                Pets Allowed
              </label>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ApartmentHouseForm;
